export default "__VITE_ASSET__CgexgU1i__"